import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import Shop from "../../../models/shop.model";
import WorkingTask from "../../../models/working-task.model";
import { ShopService } from "../../../services/shop.service";
import { Customer } from "../../../models/customer.model";
import { CustomerService } from "../../../services/customer.service";
import * as _ from "lodash";

@Component({
  selector: "ngx-dialog-print-working-task",
  templateUrl: "dialog-print-working-task.component.html",
  styleUrls: ["dialog-print-working-task.component.scss"],
})
export class DialogPrintWorkingTaskComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() shop?: Shop;
  @Input() task?: WorkingTask;

  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  printing = false;
  displayName = "";

  currentDate: Date = new Date();
  customer?: Customer;
  maxChars = 100;
  get remainingLines(): number {
    const numberOfLines = (this.task.title.match(/\n/g) || []).length + 1; // Đếm số dòng
    return Math.max(6 - numberOfLines, 0); // Số dòng trống còn lại
  }

  constructor(
    protected ref: NbDialogRef<DialogPrintWorkingTaskComponent>,
    private userService: UserService,
    private customerService: CustomerService,
    private shopService: ShopService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
          this.shop = this.shopService.shop;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });

    this.customer =
      this.task.customerId !== ""
        ? _.find(this.customerService.customers, {
            id: this.task.customerId,
          })
        : new Customer();
    console.log(
      "🚀 ~ .subscribe ~ this.this.task.customerId:",
      this.task.customerId
    );
    console.log("🚀 ~ .subscribe ~ this.customer:", this.customer);
    console.log("🚀 ~ ngOnInit ~ this.task:", this.task);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // this.print();
    }, 1000);
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.printing = true;
    let el: HTMLElement = this.printBtn.nativeElement;
    el.click();
    this.ref.close(true);
  }
}
